import React from 'react';
import { useSelector } from 'react-redux';
import WDDialog from './WDDialog';

export default function DialogsContainer() {
  const notifications = useSelector((state) => state.dialogs);
  return notifications.map(o => (<WDDialog key={o.id} {...o} />));
}
